(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loox-review-button"] && !Shopify.designMode) return;
  try {
    
function waitForLoox(callback, maxWait = 30000) {
  const startTime = Date.now();
  
  function checkLoox() {
    if (typeof window.loox !== 'undefined') {
      callback();
    } else if (Date.now() - startTime < maxWait) {
      setTimeout(checkLoox, 500);
    } else {
      console.error('Loox failed to initialize after', maxWait / 1000, 'seconds');
    }
  }
  
  checkLoox();
}

function initLooxButton() {
  const button = document.getElementById('write');
  
  if (!button) {
    console.error('Loox Review Button not found');
    return;
  }

  function handleClick(e) {
    e.preventDefault();
    const productId = button.getAttribute('data-product-id');

    waitForLoox(function() {
      try {
        window.loox.openReviewForm({
          id: productId,
          source: 'custom_button'
        });
      } catch (error) {
        console.error('Error opening Loox review form:', error);
      }
    }, 5000); // Wait up to 5 seconds for Loox when button is clicked
  }

  // Remove existing listeners and add new one
  button.replaceWith(button.cloneNode(true));
  const newButton = document.getElementById('write');
  newButton.addEventListener('click', handleClick);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLooxButton);
} else {
  initLooxButton();
}

// Reinitialize when Shopify section is reloaded
document.addEventListener('shopify:section:load', initLooxButton);

// Optional: Log Loox status for debugging
waitForLoox(function() {
  console.log('Loox is available');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
